import type { CommunityNote } from "../../api/community";
import type { MaterialItem } from "../../api/library";
import { coverForNote } from "../community/community-data";

export const homeHighlights = [
  "编辑 3D 场景",
  "比较材质工艺",
  "连接创作者案例",
];

export const HOME_HERO_FALLBACK = "/image/hero-moodshow-orbit.png";
export const HOME_HERO_SCENE = "/image/hero-home-scene.jpg";

export type MaterialTypeOption = {
  value: string;
  label: string;
};

export function pickCoveredNotes(preferred: CommunityNote[], limit: number, fallback: CommunityNote[] = []) {
  const seen = new Set<string>();
  const picked: CommunityNote[] = [];
  for (const item of [...preferred, ...fallback]) {
    if (seen.has(item.id) || !coverForNote(item)) continue;
    seen.add(item.id);
    picked.push(item);
    if (picked.length >= limit) break;
  }
  return picked;
}

export function noteKind(note: CommunityNote) {
  const topic = note.topic?.replace(/^#/, "").trim();
  if (topic) return topic;
  if (note.hasScene) return "3D 场景";
  if (note.type === "featured") return "精选案例";
  return "社区作品";
}

export function materialTint(item: MaterialItem) {
  const raw = item.showcase?.colorHex || item.renderParams?.color || "";
  const value = raw.trim();
  if (/^#?[0-9a-fA-F]{3,8}$/.test(value)) return value.startsWith("#") ? value : `#${value}`;
  return "#9aa39d";
}

export function materialTypeLabel(type: string | undefined, types: MaterialTypeOption[]) {
  const value = (type || "").trim();
  if (!value || value === "undefined") return "其他";
  return types.find((item) => item.value === value)?.label || value;
}

export function materialTabs(items: MaterialItem[], types: MaterialTypeOption[]) {
  const seen = new Set<string>();
  const tabs: MaterialTypeOption[] = [{ value: "all", label: "全部" }];
  for (const item of items) {
    const value = (item.type || "").trim() || "undefined";
    if (seen.has(value)) continue;
    seen.add(value);
    tabs.push({ value, label: materialTypeLabel(value, types) });
  }
  return tabs;
}
